export const getters = {
  powerBiParams: ({ powerBiParams }) => powerBiParams,
};
